import React, {useState} from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
// import PerfectScrollbar from 'react-perfect-scrollbar';

import Nav from './VerticalNavWrapper';
// import HeaderLogo from './AppLogo';
import {setEnableMobileMenu} from '../actions/ThemeOptions';

import {
    IonMenu,
    IonHeader,
    IonToolbar,
    IonContent,
    IonImg,
    IonThumbnail,
    // IonButton,
    // IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    // IonFooter,
} from '@ionic/react';

// const qrCodeIcon = <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M16.5 19.25V17.875H17.875V19.25H16.5Z" fill="#DEE2E5"/>
//     <path d="M12.375 16.5V15.125H13.75V16.5H12.375Z" fill="#DEE2E5"/>
//     <path d="M12.375 20.625H15.125V19.25H13.75V17.875H12.375V20.625Z" fill="#DEE2E5"/>
//     <path d="M17.875 17.875V15.125H19.25V17.875H17.875Z" fill="#DEE2E5"/>
//     <path d="M19.25 17.875H20.625V20.625H17.875V19.25H19.25V17.875Z" fill="#DEE2E5"/>
//     <path d="M17.875 13.75V12.375H20.625V15.125H19.25V13.75H17.875Z" fill="#DEE2E5"/>
//     <path d="M16.5 13.75H15.125V16.5H13.75V17.875H16.5V13.75Z" fill="#DEE2E5"/>
//     <path d="M12.375 13.75V12.375H15.125V13.75H12.375Z" fill="#DEE2E5"/>
//     <path d="M4.125 15.125H6.875V17.875H4.125V15.125Z" fill="#DEE2E5"/>
//     <path d="M9.625 20.625H1.375V12.375H9.625V20.625ZM2.75 19.25H8.25V13.75H2.75V19.25Z" fill="#DEE2E5"/>
//     <path d="M15.125 4.125H17.875V6.875H15.125V4.125Z" fill="#DEE2E5"/>
//     <path d="M20.625 9.625H12.375V1.375H20.625V9.625ZM13.75 8.25H19.25V2.75H13.75V8.25Z" fill="#DEE2E5"/>
//     <path d="M4.125 4.125H6.875V6.875H4.125V4.125Z" fill="#DEE2E5"/>
//     <path d="M9.625 9.625H1.375V1.375H9.625V9.625ZM2.75 8.25H8.25V2.75H2.75V8.25Z" fill="#DEE2E5"/>
// </svg>

const AppSidebar = (
    {
        enableMobileMenu,
        enableBackgroundImage,
        enableSidebarShadow,
        backgroundColor,
        backgroundImage,
        backgroundImageOpacity,

        setEnableMobileMenu,
        activeShop,
        bots,

        networkState,
    }
) => {

    const [error, setError] = useState(false);
    if(!bots) {
        return null;
    }

    return <IonMenu className="i-menu" content-id="main-content">
        <IonHeader mode="md">
            <IonToolbar className={cx("i-menu-header", {"i-menu-header_offline": !networkState})}>
                <IonGrid className="i-menu-header-container">
                    <IonRow>
                        <IonCol size="9">
                            <IonThumbnail className="i-menu-header-img">
                                {
                                    bots[0]?.photo && !error
                                    ? <IonImg src={bots[0]?.photo} onIonError={(data) => {
                                          setError(true)
                                      }}  />
                                    : bots[0]?.name[0] && bots[0]?.name[0].toUpperCase()
                                }
                            </IonThumbnail>
                            <div className="i-menu-header-name">{bots[0]?.name}</div>
                            <div className="i-menu-header-phone">{bots[0]?.wa_phone_number}</div>
                        </IonCol>
                        {/* <IonCol size="3">
                            <IonButtons className="i-menu-header-qr_code">
                                <IonButton>
                                    {qrCodeIcon}
                                </IonButton>
                            </IonButtons>
                        </IonCol> */}
                    </IonRow>
                </IonGrid>
                {/* <IonTitle size="small">
                    <span className="text-nowrap">{activeShop.trade_name}</span>
                </IonTitle> */}
            </IonToolbar>
        </IonHeader>
        <IonContent forceOverscroll={false}>
            <Nav />
        </IonContent>
        {/* <IonFooter className="i-menu-footer">
            <IonImg src={} className="i-menu-footer-logo"/>
        </IonFooter> */}
    </IonMenu>

}

const mapStateToProps = state => ({
    enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
    enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
    backgroundColor: state.ThemeOptions.backgroundColor,
    backgroundImage: state.ThemeOptions.backgroundImage,
    backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity,
    activeShop: state.Shops.activeShop,
    bots: state.Bots.bots,
    networkState: state.Auth.networkState,
});

const mapDispatchToProps = dispatch => ({
    setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebar);
